import PROFIL_ECRITURE from '../../../constants/mouvements/codeProfilEcritures';
import CompteDeTiersPanel from '../panel/CompteDeTiersPanel';
import CovidPanel from '../panel/CovidPanel';
import DetailDeFacturationPanel from '../panel/DetailDeFacturationPanel';
import EditionAsapDematerialiseePanel from '../panel/EditionAsapDematerialiseePanel';
import SaisieLibrePanel from '../panel/InformationsRattachement/SaisieLibrePanel';
import InventairePanel from '../panel/InventairePanel';
import NumeroEmpruntPanel from '../panel/NumeroEmpruntPanel';
import PeriodeCouvertePanel from '../panel/PeriodeCouvertePanel';
import ProjetPanel from '../panel/ProjetPanel';
import RegiePanel from '../panel/RegiePanel';
import RoleDeRecouvrementPanel from '../panel/RoleDeRecouvrementPanel';
import TravauxEnRegiePanel from '../panel/TravauxEnRegiePanel';
import TypologiePesPanel from '../panel/TypologiePesPanel';
import BaseProfilEcritureRecette from './Base/BaseProfilEcritureRecette';

class ProfilEcritureLibreRecette extends BaseProfilEcritureRecette {
  constructor() {
    super();
    this.code = PROFIL_ECRITURE.RECETTE.SAI_LIB;
    this.panels = [
      ...this.panels,
      new CompteDeTiersPanel(),
      new CovidPanel(),
      new DetailDeFacturationPanel(),
      new EditionAsapDematerialiseePanel(),
      new InventairePanel(),
      new NumeroEmpruntPanel(),
      new PeriodeCouvertePanel(),
      new ProjetPanel(),
      new RegiePanel(),
      new RoleDeRecouvrementPanel(),
      new TravauxEnRegiePanel(),
      new TypologiePesPanel(true),
      new SaisieLibrePanel(),
      // TODO : add "Marche public" optional panel
    ];
  }
}

export default ProfilEcritureLibreRecette;
